import React, { useEffect, useState } from "react";
import { Button,Modal} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { WMSInput } from "../../widgets/input";
import CustomTable from "../table/customTable";
import { createColumnHelper } from "@tanstack/react-table";
import { invokeGetService, invokePostService } from "../../service";
import { connect } from "react-redux";
import { apiUrl } from "../../base/utils";
import { toastError, toastSuccess } from "../../widgets/toaster";
import { WMSSelect } from "../../widgets/selectbox";
import HOCAutoLogout from "../autologout";

interface Errors {
  [key: string]: string;
}

const inputFields = [
  {
    label: "First Name",
    type: "text",
    placeholder: "Enter first name",
    required: true,
    pattern: /^[a-zA-Z]+$/,
    maxLength: "50",
  },
  {
    label: "Last Name",
    placeholder: "Enter last name",
    required: true,
    pattern: /^[a-zA-Z]+$/,
    maxLength: "50",
  },
  {
    label: "Email Id",
    placeholder: "Enter email Id",
    required: true,
    type: "email",
    maxLength: "100",
    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  },
  {
    label: "Address Line1",
    placeholder: "Enter address",
    required: false,
    maxLength: "300",
  },
  {
    label: "Address Line2",
    placeholder: "Enter address",
    required: false,
    maxLength: "300",
  },
  {
    label: "Post Code",
    placeholder: "Enter post Code",
    type: "text",
    required: false,
    pattern: "^[1-9][0-9]*$",
    maxLength: "12",
  },
  {
    label: "City",
    placeholder: "Enter city",
    required: false,
    maxLength: "100",
  },
  {
    label: "State",
    placeholder: "Enter state",
    required: false,
    maxLength: "100",
  },
  {
    label: "Country",
    placeholder: "Select country",
    required: false,
    type: "select",
    options: [], // Empty initially
  },
  {
    label: "Phone Number",
    placeholder: "Enter phone number",
    type: "text",
    required: false,
    pattern: "^(\\+\\d{1,3}[- ]?)?\\d{10}$",
    maxLength: "14",
  },
  {
    label: "Author has address to receive hard copy",
    placeholder: "",
    required: false,
    disabled: true,
    type: "select",
    options: [
      { id: "Yes", label: "Yes", value: "Yes" },
      { id: "No", label: "No", value: "No" },
    ],
  },
];

const AddAuthor: React.FC = (props: any) => {
  const navigate = useNavigate();
  const columnHelper = createColumnHelper();

  const [formValues, setFormValues] = useState<any>({});
  const [errors, setErrors] = useState<Errors>({});

  const [authorData, setAuthorData] = useState<any[]>([]);
  const [isLoader, setIsLoader] = useState(false);
  const [countryOptions, setCountryOptions] = useState<any[]>([]);

  const [emailStatus, setEmailStatus] = useState("");

  const [isEditMode, setIsEditMode] = useState(false);
  const [currentAuthorId, setCurrentAuthorId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState<any>(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [setemail, setSetEmail] = useState("");
  const location = useLocation();
  const { row, currentState } = location.state || {};

  // Effect for Data Fetching
  useEffect(() => {
    if (row?.articleid) {
      fetchAuthorData(row.articleid);
      getAuthorinfomation(row.articleid);
    }
    getCountryOptList();
  }, []);
  const handleCancel = () => {
    setShowModal(false);
  };
  useEffect(() => {
    // Populate form fields when currentState changes
    if (currentState) {
      setFormValues({
        firstname: currentState.assignee,
        lastname: "", // Set as needed
        emailid: "", // Set as needed
        addressline1: currentState.addressline1,
        addressline2: currentState.addressline2,
        postcode: currentState.postcode,
        state: currentState.state,
        city: currentState.city,
        country: {
          id: currentState.journalsvalue?.id,
          label: currentState.journalsvalue?.label,
          value: currentState.journalsvalue?.value,
        },
        phonenumber: "", // Set as needed
      });
    }
  }, [currentState]);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: string
  ) => {
    const value = e.target.value;

    setFormValues({
      ...formValues,
      [field]: value,
    });

    const fieldError = validateField(
      inputFields.find(
        (f) => f.label.replaceAll(" ", "").toLowerCase() === field
      ),
      value
    );

    setErrors({
      ...errors,
      [field]: fieldError,
    });
  };

  const handleFormSelection = (value: any, field: string) => {
    setFormValues({
      ...formValues,
      [field]: value,
    });

    setErrors({
      ...errors,
      [field]: "",
    });
  };

  const handleEdit = (author: any) => {
    setFormValues({
      firstname: author.firstname,
      lastname: author.lastname,
      emailid: author.email,
      addressline1: author.addressline1,
      addressline2: author.addressline2,
      postcode: author.postcode,
      state: author.state,
      city: author.city,
      country: {
        id: author.countryid,
        label: author.country,
        value: author.country,
      },
      phonenumber: author.phonenumber,
      authorhasaddresstoreceivehardcopy: {
        id: author.hashardcopyreceiveaddress ? "Yes" : "No",
        value: author.hashardcopyreceiveaddress ? "Yes" : "No",
        label: author.hashardcopyreceiveaddress ? "Yes" : "No",
      },
    });
    setCurrentAuthorId(author.id);
    setIsEditMode(true);
  };

  const validateField = (field: any, value: string) => {
    if (field.required && !value) {
      return `${field.label} is required`;
    } else if (field.label === "Email Id" && value) {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailPattern.test(value)) {
    return "Invalid email format";
  }
}
 else if (
      (field.label === "First Name" || field.label === "Last Name") &&
      value &&
      !/^[a-zA-Z\s]+$/.test(value)
    ) {
      return `${field.label} should contain only alphabetic characters`;
    } else if (
      (field.label === "City" || field.label === "State") &&
      value &&
      !/^[a-zA-Z\s]+$/.test(value)
    ) {
      return `${field.label} should contain only alphabetic characters and spaces`;
    } else if (
      field.pattern &&
      value &&
      typeof field.pattern === "string" &&
      !new RegExp(field.pattern).test(value)
    ) {
      return `Invalid format for ${field.label}`;
    }
    return "";
  };

  const validateForm = () => {
    const newErrors: Errors = {};
    let isValid = true;

    inputFields.forEach((field) => {
      const fieldName = field.label.replaceAll(" ", "").toLowerCase();
      const fieldValue = formValues[fieldName];

      const error = validateField(field, fieldValue);

      if (error) {
        newErrors[fieldName] = error;
        isValid = false;
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  // Function to add author
  const handleAdd = async () => {
    try {
      const isValid = validateForm();
      if (!isValid){
        toastError('Please fill in all the mandatory fields')
        return; 
      } 

      const fieldValue = formValues["emailid"];
      const isEmailExists = await checkEmailAvailability(fieldValue);

      if (isEmailExists) return;

      const url = apiUrl.nodeApi.insertE2EAuthorInfo;
      const payload = {
        ...formValues,
        articleid: row?.articleid || null,
        authorname: formValues?.firstname + " " + formValues?.lastname,
        authortype: 1, // main author
        createdby: props?.userInfo?.userid,
        countryid: formValues?.country?.id,
        country: formValues?.country?.label,
      };

      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );

      if (response.data.data.isSuccess) {
        toastSuccess("Author added successfully");
        const clearedFormValues: any = {};
        inputFields.forEach((field) => {
          clearedFormValues[field.label.replaceAll(" ", "").toLowerCase()] = "";
        });
        setFormValues(clearedFormValues);
        fetchAuthorData(row.articleid);
      } else {
        toastError(response.data.data.Error);
        throw new Error(response.data.data.Error);
      }
    } catch (error: any) {
      toastError(error || "Something went wrong");
    }
  };

  // Fetch author data
  const fetchAuthorData = async (articleId: any) => {
    try {
      let url = apiUrl.nodeApi.getAuthorByArticleId;
      setIsLoader(true);
      const response: any = await invokeGetService(
        url,
        {},
        { articleId: articleId },
        props.isToken
      );
      setIsLoader(false);
      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);

      setAuthorData(response.data.data.result);
    } catch (error) {
      console.error("Error fetching author data:", error);
      setIsLoader(false);
    }
  };

  // Function to deactivate author
  const deactivateE2EAuthor = async (item: any) => {
    try {
      let url = apiUrl.nodeApi.deactivateE2EAuthor;
      let payload = {
        id: item.id,
      };
      setIsLoader(true);
      console.log(payload, "payload");
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      setIsLoader(false);
      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);
      toastSuccess("Author Deleted Successfully");
      await fetchAuthorData(item.articleid);
    } catch (error) {
      toastError(`${error}`);
    }
  };

  // Function to get author information
  const getAuthorinfomation = async (articleid: any) => {
    try {
      let url = apiUrl.nodeApi.getAuthorinfo;
      let payload = {
        articleid: articleid,
      };
      setIsLoader(true);
      console.log(payload, "payload");
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      setIsLoader(false);
      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);
      const authorInfo = response.data.data.result[0];
      setSetEmail(authorInfo.email)
      const authorhasaddresstoreceivehardcopy: any = {
        id: authorInfo?.hashardcopyreceiveaddress ? "Yes" : "No",
        value: authorInfo?.hashardcopyreceiveaddress ? "Yes" : "No",
        label: authorInfo?.hashardcopyreceiveaddress ? "Yes" : "No",
      };

      setFormValues({
        firstname: authorInfo.firstname,
        lastname: authorInfo.lastname,
        emailid: authorInfo.email,
        addressline1: authorInfo.addressline1,
        addressline2: authorInfo.addressline2,
        postcode: authorInfo.postcode,
        state: authorInfo.state,
        city: authorInfo.city,
        country: {
          id: authorInfo?.countryid,
          value: authorInfo?.name,
          label: authorInfo?.name,
        },
        phonenumber: authorInfo.contactno,
        authorhasaddresstoreceivehardcopy: authorhasaddresstoreceivehardcopy,
      });
    } catch (error) {
      toastError(`${error}`);
    }
  };

  // Check email availability
  const checkEmailAvailability = async (email: any): Promise<boolean> => {
    try {
      const url = apiUrl.nodeApi.getEmailAvailabilityInAuthorInfo;
      const queryParams = { email: email, articleId: row?.articleid };

      const response: any = await invokeGetService(
        url,
        {},
        queryParams,
        props.isToken
      );

      if (!response.data.data.isSuccess) {
        setEmailStatus("Already mail registered");
        toastError("This email is already registered.")
        return true;
      } else {
        setEmailStatus("");
        return false;
      }
    } catch (error) {
      toastError("Failed to check email availability.");
      return false;
    }
  };

  // Handle blur event
  const handleBlur = async (e: any, type: any) => {
  if (
    type === "email" &&
    e.target.value.length > 0 &&
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(e.target.value)
  ) {
    await checkEmailAvailability(e.target.value);
  }
};


  // Back navigation
  const handleBack = () => {
    navigate("/movearticle", { state: currentState });
  };

  // Fetch country options
  const getCountryOptList = async () => {
    try {
      let url = apiUrl.nodeApi.getCountry;
      const response: any = await invokeGetService(url, {}, {}, props.isToken);
      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);
      setCountryOptions(response.data.data.result);
    } catch (error) {
      toastError(`Get Country Options ${error}`);
    }
  };

  // Define columns for author table
  const authorColumns = [
    columnHelper.accessor("firstname", {
      header: "First Name",
    }),
    columnHelper.accessor("lastname", {
      header: "Last Name",
    }),
    columnHelper.accessor("email", {
      header: "Email Id",
    }),
    columnHelper.accessor("addressline1", {
      header: "Address Line1",
    }),
    columnHelper.accessor("addressline2", {
      header: "Address Line2",
    }),
    columnHelper.accessor("postcode", {
      header: "Post Code",
    }),
    columnHelper.accessor("city", {
      header: "City",
    }),
    columnHelper.accessor("state", {
      header: "State",
    }),
    columnHelper.accessor("country", {
      header: "Country",
    }),
    columnHelper.accessor("phonenumber", {
      header: "Phone Number",
    }),
    columnHelper.accessor("hashardcopyreceiveaddress", {
      header: "Hardcopy required?",
      cell: ({ row }: any) => {
        return (
          <>
            <span>
              {row?.original?.hashardcopyreceiveaddress ? "Yes" : "No"}
            </span>
          </>
        );
      },
    }),
    columnHelper.accessor("action", {
      header: "Action",
      cell: (row: any) => {
        const rowData = row?.row?.original;

        return (
          <>
            <button
              onClick={() => handleEdit(rowData)}
              title="Edit"
              style={{
                border: "none",
                background: "none",
                cursor: currentState?.ismovedtoproduction
                  ? "not-allowed"
                  : "pointer",
                color: currentState?.ismovedtoproduction ? "#ccc" : "inherit",
              }}
              disabled={currentState?.ismovedtoproduction}
            >
              <span className="material-symbols-outlined f-20">edit</span>
            </button>
            <button
              
              title="Delete"
              style={{
                border: "none",
                background: "none",
                cursor: currentState?.ismovedtoproduction
                  ? "not-allowed"
                  : "pointer",
                color: currentState?.ismovedtoproduction ? "#ccc" : "inherit",
              }}
              disabled={
                currentState?.ismovedtoproduction ||rowData.email === setemail 
              }             
              
              onClick={() =>
              {
                setSelectedRows(rowData);
                setShowModal(true); // Show modal
              
                }}
            >
              <span className="material-symbols-outlined f-20">delete</span>
            </button>
          </>
        );
      },
    }),
  ];

  const handleUpdate = async () => {
    try {
      const isValid = validateForm();

      if (!isValid) return;

      const url = `${apiUrl.nodeApi.updateE2EAuthorInfo}/${currentAuthorId}`;
      const payload = {
        ...formValues,
        id: currentAuthorId || null,
        articleid: row?.articleid || null,
        authorname: formValues?.firstname + " " + formValues?.lastname,
        authortype: 1, // main author
        createdby: props?.userInfo?.userid,
        countryid: formValues?.country?.id,
        country: formValues?.country?.label,
      };

      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );

      if (response.data.data.isSuccess) {
        toastSuccess("Author updated successfully");
        setIsEditMode(false);
        setCurrentAuthorId(null);
        const clearedFormValues: any = {};
        inputFields.forEach((field) => {
          clearedFormValues[field.label.replaceAll(" ", "").toLowerCase()] = "";
        });
        setFormValues(clearedFormValues);
        fetchAuthorData(row.articleid);
      } else {
        toastError(response.data.data.Error);
        throw new Error(response.data.data.Error);
      }
    } catch (error: any) {
      toastError(error);
    }
  };
  const handleDelete = ()=>{
    deactivateE2EAuthor(selectedRows);
    setShowModal(false);
  }
  return (
    <>
    <Modal show={showModal} onHide={handleCancel}>
            <Modal.Header closeButton>
              <Modal.Title>Confirm Deletion</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you want to delete the author?</Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={handleCancel}>
                CANCEL
              </Button>
              <Button onClick={handleDelete}>DELETE</Button>
            </Modal.Footer>
          </Modal>
      <div className="page-title">
        <div className="d-flex">
          <Button
            onClick={handleBack}
            className="iconBtn"
            title="Back"
            style={{ padding: "0px" }}
          >
            <span className="material-icons">chevron_left</span>
          </Button>
          <h3>Add author</h3>
        </div>
      </div>
      <div className="row">
        {inputFields.map((field, index) => (
          <React.Fragment key={index}>
            <div className="col-lg-3 form-group">
              <label>
                {field.label}
                {field.required && <span className="error">*</span>}
              </label>
              {field.type === "select" ? (
                <WMSSelect
                  options={
                    field.label === "Country" ? countryOptions : field.options
                  }
                  value={
                    formValues[field.label.replaceAll(" ", "").toLowerCase()]
                  }
                  onChange={(value: any) =>
                    handleFormSelection(
                      value,
                      field.label.replaceAll(" ", "").toLowerCase()
                    )
                  }
                  disabled={ (field.label === "Country") ? currentState?.ismovedtoproduction : field?.disabled }
                />
              ) : (
                <WMSInput
                  placeHolder={field.placeholder}
                  className="form-control f-14"
                  type={field?.type}
                  maxLength={field?.maxLength}
                  value={
                    (formValues as any)[
                      field.label.replaceAll(" ", "").toLowerCase() as keyof any
                    ]
                  }
                  onBlur={(e: any) => handleBlur(e, field?.type)}
                  onChange={(e: any) =>
                    handleInputChange(
                      e,
                      field.label.replaceAll(" ", "").toLowerCase()
                    )
                  }
                  id={field.label.replaceAll(" ", "").toLowerCase()}
                  disabled={currentState?.ismovedtoproduction}
                />
              )}
              {errors[field.label.replaceAll(" ", "").toLowerCase()] && (
                <div className="text-danger f-14 mt-10">
                  {errors[field.label.replaceAll(" ", "").toLowerCase()]}
                </div>
              )}

              {field?.type === "email" ? (
                <span className="error">{emailStatus}</span>
              ) : null}
            </div>
            {index % 2 === 1 && <div className="w-100"></div>}
          </React.Fragment>
        ))}
      </div>
        <Button
          className="btn btn-primary"
          onClick={isEditMode ? handleUpdate : handleAdd}
          disabled={currentState?.ismovedtoproduction}
        >
          {isEditMode ? "Update Author" : "Add Author"}
        </Button>

      <div style={{ paddingTop: "10px" }}>
        {isLoader ? (
          <div>Loading...</div>
        ) : (
          <CustomTable
            columns={authorColumns}
            data={authorData}
            showPagination={true}
            isSearchable={false}
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  isLogged: state.rootReducer.authReducer.isLoggedIn,
  isToken: state.rootReducer.authReducer.token,
  userInfo: state.rootReducer.authReducer.userInfo,
});

export default connect(mapStateToProps, null)(HOCAutoLogout(AddAuthor));
